import { render } from "./my-fund.vue?vue&type=template&id=c43a5ab2"
import script from "./my-fund.vue?vue&type=script&lang=js"
export * from "./my-fund.vue?vue&type=script&lang=js"

import exportComponent from "/Users/n0m4dz/workspace/projects/seeroo-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__